import Select from "react-select";

const SelectField = ({
  label,
  name,
  options = [],
  value,
  onChange,
  error,
  touched,
  required = false,
  loading,
  disabled = false,
  getOptionColor,
  controlHeight = "34px",
  menuHeight = "100%",
  menuWidth = "100%",
  ismulti = false,
  placeholderFontSize = "child-text",
  labelFontSize = "14px",
  onInputChange,
  ...selectProps
}) => {
  const formattedOptions = options.map((option) => ({
    value: option.id,
    label: option.name,
    color: getOptionColor ? getOptionColor(option) : undefined,
    ...option,
  }));

  const selectedOption = ismulti
    ? formattedOptions.filter((opt) => value?.includes(opt.value))
    : formattedOptions.find((opt) => opt.value === value) || null;

  const handleChange = (selected) => {
    if (disabled) return;

    let value;

    if (ismulti) {
      value = Array.isArray(selected)
        ? selected.map(item => item.value)
        : [];
    } else {
      value = selected?.value ?? "";
    }

    onChange({
      target: {
        name,
        value,
        option: selected,
      },
    });
  };

  return (
    <div className="flex flex-col gap-0.5 w-full ">
      <label
        className="child-text font-semibold"
        style={{ fontSize: labelFontSize }}
      >
        {label}
        {required && <span className="text-red-500 ml-1">*</span>}
      </label>

      <Select
        name={name}
        options={formattedOptions}
        value={selectedOption}
        onChange={handleChange}
        onInputChange={onInputChange}
        placeholder="Select"
        className="child-text"
        classNamePrefix="custom-select"
        isLoading={loading}
        isDisabled={disabled}
        {...selectProps}
        isMulti={ismulti}
        menuPortalTarget={document.body}
        menuPosition="fixed"
        menuPlacement="auto"
        styles={{
          control: (base, state) => ({
            ...base,
            minHeight: controlHeight,
            height: controlHeight,
            backgroundColor: disabled ? "#e5e7eb" : "white",
            cursor: state.isDisabled ? "not-allowed" : "pointer",
            borderColor: state.isFocused
              ? "#6366f1"
              : base.borderColor,
          }),
          placeholder: (base) => ({
            ...base,
            fontSize: placeholderFontSize,   // Change as needed
            color: "#9CA3AF",   // Optional 
          }),

          singleValue: (base, state) => ({
            ...base,
            fontSize: placeholderFontSize,
            color: state.data.color || "#111",
            fontWeight: 500,
            cursor: state.isDisabled ? "not-allowed" : "pointer",
          }),

          option: (base, state) => ({
            ...base,
            color: state.data.color || "#111",
            fontWeight: 500,
            cursor: state.isDisabled ? "not-allowed" : "pointer",
            backgroundColor: state.isFocused
              ? "#f3f4f6"
              : "white",
          }),

          valueContainer: (base, state) => ({
            ...base,
            height: controlHeight,
            padding: "0 8px",
            cursor: state.isDisabled ? "not-allowed" : "pointer",
          }),

          indicatorsContainer: (base, state) => ({
            ...base,
            height: controlHeight,
            cursor: state.isDisabled ? "not-allowed" : "pointer",
          }),

          menuPortal: (base, state) => ({
            ...base,
            zIndex: 9999,
            cursor: state.isDisabled ? "not-allowed" : "pointer",
          }),
          menu: (base, state) => ({
            ...base,
            width: menuWidth,
            minWidth: menuWidth,
            cursor: state.isDisabled ? "not-allowed" : "pointer",
          }),
          menuList: (provided, state) => ({
            ...provided,
            maxHeight: menuHeight,
            cursor: state.isDisabled ? "not-allowed" : "pointer",
          }),
        }}
      />

      <div className="min-h-[7px]">
        {error && touched && (
          <span className="error-text">{error}</span>
        )}
      </div>
    </div>
  );
};

export default SelectField;